import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const UserSquare = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 52 53"
      fill={fill}
      stroke="#EE2D58"
      {...rest}
    >
      <g id="vuesax/linear/user-square">
        <g id="user-square">
          <path
            id="Vector"
            d="M39.302 47.0008C37.3953 47.5642 35.142 47.8242 32.4986 47.8242H19.4986C16.8553 47.8242 14.602 47.5642 12.6953 47.0008C13.172 41.3675 18.957 36.9258 25.9986 36.9258C33.0403 36.9258 38.8253 41.3675 39.302 47.0008Z"
            strokeWidth="3.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M32.4987 4.49121H19.4987C8.66536 4.49121 4.33203 8.82454 4.33203 19.6579V32.6579C4.33203 40.8479 6.80203 45.3329 12.6954 47.0012C13.172 41.3679 18.957 36.9261 25.9987 36.9261C33.0404 36.9261 38.8254 41.3679 39.302 47.0012C45.1954 45.3329 47.6654 40.8479 47.6654 32.6579V19.6579C47.6654 8.82454 43.332 4.49121 32.4987 4.49121ZM25.9987 30.8595C21.7087 30.8595 18.242 27.3712 18.242 23.0812C18.242 18.7912 21.7087 15.3245 25.9987 15.3245C30.2887 15.3245 33.7554 18.7912 33.7554 23.0812C33.7554 27.3712 30.2887 30.8595 25.9987 30.8595Z"
            strokeWidth="3.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M33.7555 23.0819C33.7555 27.3719 30.2889 30.8602 25.9989 30.8602C21.7089 30.8602 18.2422 27.3719 18.2422 23.0819C18.2422 18.7919 21.7089 15.3252 25.9989 15.3252C30.2889 15.3252 33.7555 18.7919 33.7555 23.0819Z"
            strokeWidth="3.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

UserSquare.displayName = 'UserSquare';
